(() => {
  if (window.irWrapSupportReady) return;
  window.irWrapSupportReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ir-wrap-support]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const open = () => {
      if (typeof window.Intercom !== 'function') return false;
      window.Intercom('show');
      return true;
    };
    if (open()) return;
    button.setAttribute('aria-busy', 'true');
    const started = Date.now();
    const timer = setInterval(() => {
      const opened = open();
      if (!opened && Date.now() - started < 30000) return;
      clearInterval(timer);
      button.removeAttribute('aria-busy');
      if (!opened) window.alert('Support chat could not load. Please refresh the page and try again.');
    }, 200);
  });
})();
